export default __webpack_public_path__ + "static/media/bag.7970e1af.svg";